module.exports = __webpack_public_path__ + "img/icon-down-dark.6dbb5a06.svg";